import script from "./DeviceRoleSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceRoleSetting.vue?vue&type=script&setup=true&lang=js"

import "./DeviceRoleSetting.vue?vue&type=style&index=0&id=bf127472&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf127472"]])

export default __exports__